export default __webpack_public_path__ + "static/media/notebook.268e1da7.svg";